import { Tower } from '../../models/tower';

import { ApiResponse, httpService } from '../httpService';

export interface GetTowerParams {
  skip?: number;
  take?: number;
  filter?: string;
  includeDeleted?: boolean;
}

const towersApiUrl = '/api/Tower';

export const getTower = async (
  params: GetTowerParams = {}
): Promise<ApiResponse<Tower>> => {
  const response = await httpService.get<ApiResponse<Tower>>(
    `${towersApiUrl}/`,
    {
      params,
    }
  );

  return response.data;
};

export const getTowerById = async (idTower: string): Promise<Tower> => {
  const response = await httpService.get<Tower>(
    `${towersApiUrl}/${idTower}`
  );

  return response.data;
};

export const addNewTower = async (
  newTower: Partial<Tower>
): Promise<void> => {
  await httpService.post(towersApiUrl, newTower);
};

export const editTower = async (
  idTower: string,
  editTowerInfo: Partial<Tower>
): Promise<void> => {
  await httpService.put(`${towersApiUrl}/${idTower}`, editTowerInfo);
};

export const deleteTower = async (idTower: string): Promise<void> => {
  await httpService.delete(`${towersApiUrl}/${idTower}`);
};

// export const getTowerById = async (idProject: string): Promise<Tower> => {
//   const response = await httpService.get<Tower>(
//     `${towersApiUrl}/${idProject}`
//   );

//   return response.data;
// };
